import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const motorRefGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'QPA') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorRefGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.MOTOR) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorRefStats = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'QPA') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorDriver is 2
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorQuoteRef' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorRefPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'QPA') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorRefPremium is 3
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorQuoteRef' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorQuoteRefStats' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
